import { FC } from 'react';
import FinancialNavArrowIcon from '../../icons/FinancialNavArrowIcon';

interface IProps {
  onTodayClick: () => void;
  onPrevClick: () => void;
  onNextClick: () => void;
  currentMonth: string;
}

const CalendarHeader: FC<IProps> = ({
  onTodayClick,
  onPrevClick,
  onNextClick,
  currentMonth,
}) => {
  return (
    <div className="event-calendar__header">
      <h2 className="event-calendar__current-month">{currentMonth}</h2>
      <div className="event-calendar__header--right-part">
        <FinancialNavArrowIcon
          className="event-calendar__nav-button"
          onClick={onPrevClick}
        />

        <FinancialNavArrowIcon
          className="event-calendar__nav-button event-calendar__nav-button--right"
          onClick={onNextClick}
        />

        <div className="event-calendar__today-button" onClick={onTodayClick}>
          Today
        </div>
      </div>
    </div>
  );
};

export default CalendarHeader;
